import script from "./ScheduleGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleGroup.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleGroup.vue?vue&type=style&index=0&id=c446cc64&lang=scss"

const __exports__ = script;

export default __exports__